import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SectionCategoryDescription.css';

const SectionCategoryDescription = ({ content }) => {
  const { mainTitleId, mainTextId, subSections } = content;
  return (
    <div className={css.root}>
      <div className={css.content}>
        <div className={css.section}>
          <h2 className={css.mainHeader}>
            <FormattedMessage id={mainTitleId} />
          </h2>
          <div className={css.text}>
            <FormattedMessage id={mainTextId} />
          </div>
        </div>
        {subSections.map(section => (
          <div key={section.id} className={css.section}>
            <h2 className={css.subHeader}>
              <FormattedMessage id={section.titleId} />
            </h2>
            <div className={css.text}>
              <FormattedMessage id={section.textId} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionCategoryDescription;
